import React, { useState } from 'react';
import {
  BackgroundModal,
  BuyButton,
  DescriptionContainer,
  InfoContainer,
  ModalContainer,
  NFTImageStyled,
  RectangleContainer,
  SampleBadgeContainer,
  SongInfoContainer,
  SongNameStyled,
  TimeframeContainer
} from '../../styles/Modal.styled';

import { SamplesBadge } from '../SamplesBadge/SamplesBadge';

import { ScaleLoader } from 'react-spinners';

import AlbumCover from '../../assets/Images/AlbumCoverImage.png';

const Modal = (props: any) => {
  const [buyConfirmed, setBuyConfirmed] = useState<boolean>(false);
  const [buyInitiated, setBuyInitiated] = useState<boolean>(false);

  const handleBuyConfirmed = () => {
    setBuyInitiated(true);
    setTimeout(() => {
      setBuyInitiated(false);
      setBuyConfirmed(true);
    }, 2000);
    setTimeout(() => {
      setBuyConfirmed(false);
    }, 4000);
  };
  return (
    <BackgroundModal onClick={props.onClick}>
      <RectangleContainer
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <ModalContainer>
          <NFTImageStyled src={AlbumCover} />
          <DescriptionContainer>
            <SampleBadgeContainer>
              <SamplesBadge
                title="DIGCHUNK"
                number={props.idChunk}
                totalNumber={180}
              />
              TIMEFRAME
            </SampleBadgeContainer>
            <InfoContainer>
              <SongInfoContainer>
                RMZ
                <SongNameStyled>Surfside</SongNameStyled>
              </SongInfoContainer>
              <TimeframeContainer>
                01:21 <br /> – <br /> 01:25
              </TimeframeContainer>
            </InfoContainer>
          </DescriptionContainer>
        </ModalContainer>
        <BuyButton onClick={handleBuyConfirmed}>
          {!buyInitiated && !buyConfirmed && 'Buy for 0.5 ETH'}
          {buyConfirmed && 'Thank you !'}
          <ScaleLoader
            color="#fff"
            height="30px"
            width="4px"
            radius="0"
            margin="2px"
            loading={buyInitiated}
          />
        </BuyButton>
      </RectangleContainer>
    </BackgroundModal>
  );
};

export default Modal;
